import binStr2ArrayBuffer from './binStr2ArrayBuffer';

export default function base64ToArrayBuffer(base64: string) {
  const binaryString = window.atob(base64);
  return binStr2ArrayBuffer(binaryString);
}
